module.exports = __webpack_public_path__ + "img/flow.af933ca3.svg";